// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ProviderWorkerReportClaimIdPage,
    ProviderWorkerReportClaimIdPageFromJSON,
    ProviderWorkerReportClaimIdPageToJSON,
    ProviderWorkerReportGroup,
    ProviderWorkerReportGroupFromJSON,
    ProviderWorkerReportGroupToJSON,
    ProviderWorkerReportWorkflowValue,
    ProviderWorkerReportWorkflowValueFromJSON,
    ProviderWorkerReportWorkflowValueToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderWorkerReport
 */
export interface ProviderWorkerReport {
    /**
     * The authenticated provider account ID. An account ID cannot be supplied to select another account.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderWorkerReport
     */
    bankUserId: string;
    /**
     * Account display name, or Unknown when unavailable.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderWorkerReport
     */
    bankUserName: string;
    /**
     * UTC reference instant used for the snapshot\'s 365-day cutoff and all age calculations.
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderWorkerReport
     */
    generatedAt: string;
    /**
     * Distinct matching claims; equals inProgressClaims + waitingClaims + errorClaims and the sum of group counts.
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof ProviderWorkerReport
     */
    totalClaims: number;
    /**
     * Matching claims whose latest action is neither a worker waiting action nor ERROR. Classification uses action, not status or step.
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof ProviderWorkerReport
     */
    inProgressClaims: number;
    /**
     * Matching claims whose latest action belongs to the worker\'s WAITING_ACTIONS set.
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof ProviderWorkerReport
     */
    waitingClaims: number;
    /**
     * Matching claims whose latest action is ERROR.
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof ProviderWorkerReport
     */
    errorClaims: number;
    /**
     * Nonempty, disjoint groups of matching claims. Sum count by status and weekBucket for collapsed heatmap rows, by status/action/weekBucket for expanded rows, and by workflow for cell tooltips and the legend. Sum across steps when constructing the dashboard\'s status and action rows; retain workflowStep for more specific lookups. Group array order is unspecified; status codes in workflowStatuses provide dashboard status ordering.
     * OpenAPI data type: {array}
     * @type {Array<ProviderWorkerReportGroup>}
     * @memberof ProviderWorkerReport
     */
    groups: Array<ProviderWorkerReportGroup>;
    /**
     * Metadata for each distinct workflowStatus returned in groups; empty when there are no groups. Sort status codes lexicographically.
     * OpenAPI data type: {array}
     * @type {Array<ProviderWorkerReportWorkflowValue>}
     * @memberof ProviderWorkerReport
     */
    workflowStatuses: Array<ProviderWorkerReportWorkflowValue>;
    /**
     * Metadata for each distinct workflowStep returned in groups; empty when there are no groups.
     * OpenAPI data type: {array}
     * @type {Array<ProviderWorkerReportWorkflowValue>}
     * @memberof ProviderWorkerReport
     */
    workflowSteps: Array<ProviderWorkerReportWorkflowValue>;
    /**
     * Global metadata for each distinct workflowAction returned in groups, sorted lexicographically by machine value; empty when there are no groups. To order actions within a status, sum counts from groups by status and action, then sort by descending count and label.
     * OpenAPI data type: {array}
     * @type {Array<ProviderWorkerReportWorkflowValue>}
     * @memberof ProviderWorkerReport
     */
    workflowActions: Array<ProviderWorkerReportWorkflowValue>;
    /**
     * Present only when includeClaimIds=true; omitted otherwise, rather than returned as null or an empty placeholder.
     * OpenAPI data type: {ProviderWorkerReportClaimIdPage}
     * @type {ProviderWorkerReportClaimIdPage}
     * @memberof ProviderWorkerReport
     */
    claimIdPage?: ProviderWorkerReportClaimIdPage;
}

export function ProviderWorkerReportFromJSON(json: any): ProviderWorkerReport {
    return {
            'bankUserId': json['bankUserId'],
            'bankUserName': json['bankUserName'],
            'generatedAt': json['generatedAt'],
            'totalClaims': json['totalClaims'],
            'inProgressClaims': json['inProgressClaims'],
            'waitingClaims': json['waitingClaims'],
            'errorClaims': json['errorClaims'],
            'groups': (json['groups'] as Array<any>).map(ProviderWorkerReportGroupFromJSON),
            'workflowStatuses': (json['workflowStatuses'] as Array<any>).map(ProviderWorkerReportWorkflowValueFromJSON),
            'workflowSteps': (json['workflowSteps'] as Array<any>).map(ProviderWorkerReportWorkflowValueFromJSON),
            'workflowActions': (json['workflowActions'] as Array<any>).map(ProviderWorkerReportWorkflowValueFromJSON),
            'claimIdPage': !exists(json, 'claimIdPage') ? undefined : ProviderWorkerReportClaimIdPageFromJSON(json['claimIdPage']),
    };

}

export function ProviderWorkerReportToForm(value?: ProviderWorkerReport): any {
    let jsonVal = ProviderWorkerReportToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderWorkerReportToJSON(value?: ProviderWorkerReport): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'bankUserId': cleanupBlankValuesForBackend(value.bankUserId),
            'bankUserName': cleanupBlankValuesForBackend(value.bankUserName),
            'generatedAt': cleanupBlankValuesForBackend(value.generatedAt),
            'totalClaims': cleanupBlankValuesForBackend(value.totalClaims),
            'inProgressClaims': cleanupBlankValuesForBackend(value.inProgressClaims),
            'waitingClaims': cleanupBlankValuesForBackend(value.waitingClaims),
            'errorClaims': cleanupBlankValuesForBackend(value.errorClaims),
            'groups': (value.groups as Array<any>).map(ProviderWorkerReportGroupToJSON),
            'workflowStatuses': (value.workflowStatuses as Array<any>).map(ProviderWorkerReportWorkflowValueToJSON),
            'workflowSteps': (value.workflowSteps as Array<any>).map(ProviderWorkerReportWorkflowValueToJSON),
            'workflowActions': (value.workflowActions as Array<any>).map(ProviderWorkerReportWorkflowValueToJSON),
            'claimIdPage': ProviderWorkerReportClaimIdPageToJSON(value.claimIdPage),
    };
}


